const ktpDataKey = 'mobile_counter_ktp_register_data';

function setData(data) {
    localStorage.setItem(ktpDataKey, JSON.stringify(data));
}

function getData() {
    const ktpData = localStorage.getItem(ktpDataKey);

    if (ktpData) {
        const data = JSON.parse(ktpData);

        return data;
    }

    return null;
}

function clearData() {
    localStorage.removeItem(ktpDataKey);
}

export default {
    setData,
    getData,
    clearData,
};